import mergeClasses from 'features/targetingV2/utils/mergeClasses';
import React from 'react';

import {
  TableCell as MUITableCell,
  TableCellProps as MUITableCellProps,
} from '@material-ui/core';

import useStyles from './TableCell.styles';

export type TableCellProps = MUITableCellProps;

const TableCell = React.forwardRef(
  (props: TableCellProps, ref: React.Ref<any>) => {
    const { classes: userClasses = {}, ...otherProps } = props;
    const classes = mergeClasses(useStyles(), userClasses);

    return <MUITableCell ref={ref} classes={classes} {...otherProps} />;
  }
);

TableCell.displayName = 'TableCell';

export default TableCell;
